/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Type of the operation.  Possible types: * `create_node` - a node will be created with specific `create` `params`. * `prepare_node` - a node will be prepared with specific `prepared` `params`. * `drain_node` - a node will be drained with specific `drain` `params`. * `delete_node` - a node will be deleted with specific `delete` `params`.
 * @export
 * @enum {string}
 */

export const CastaiAutoscalerV1beta1RebalancingPlanResponseOperationType = {
    invalid: 'invalid',
    create_node: 'create_node',
    prepare_node: 'prepare_node',
    drain_node: 'drain_node',
    delete_node: 'delete_node'
} as const;

export type CastaiAutoscalerV1beta1RebalancingPlanResponseOperationType = typeof CastaiAutoscalerV1beta1RebalancingPlanResponseOperationType[keyof typeof CastaiAutoscalerV1beta1RebalancingPlanResponseOperationType];



